/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { uom } from '../models/uom';
import type { vw_uom } from '../models/vw_uom';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UnitOfMeasurementService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postUomDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/uom/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of Unit of Measurements
     * @returns vw_uom A list of uom
     * @throws ApiError
     */
    public getUoms(): CancelablePromise<Array<vw_uom>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/uoms',
        });
    }

    /**
     * Get uom by id
     * @returns vw_uom The uom data
     * @throws ApiError
     */
    public getUom({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_uom> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/uom/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Unit of Measurement not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a uom by id
     * @returns any Unit of Measurement deleted successfully
     * @throws ApiError
     */
    public deleteUom({
        id,
    }: {
        /**
         * The uom id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/uom/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Unit of Measurement not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get uom by uom code
     * @returns vw_uom The uom data
     * @throws ApiError
     */
    public getUomFindByCode({
        uomCode,
    }: {
        uomCode: string,
    }): CancelablePromise<vw_uom> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/uom/findByCode/{uom_code}',
            path: {
                'uom_code': uomCode,
            },
            errors: {
                404: `Unit of Measurement not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Unit of Measurement
     * @returns any Unit of Measurement created successfully
     * @throws ApiError
     */
    public postUom({
        requestBody,
    }: {
        requestBody: uom,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/uom',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Unit of Measurement
     * @returns any Unit of Measurement updated successfully
     * @throws ApiError
     */
    public putUom({
        requestBody,
    }: {
        requestBody: uom,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/uom',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Unit of Measurement not found`,
                500: `Internal server error`,
            },
        });
    }

}
